let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kd1UR")).then(() => parcelRequire('ejLY3'));